import { useMemo } from 'react'

interface InputEditedParams {
  questionsLength: number
  selectedQuestionIndex: number
  currentAnswer: string | null | undefined
  mainAnswer: string | null | undefined
  currentQuestion: string
  mainQuestion: string
}

export const isInputEdited = ({
  questionsLength,
  selectedQuestionIndex,
  currentAnswer,
  mainAnswer,
  currentQuestion,
  mainQuestion,
}: InputEditedParams): { canBeUpdated: boolean } => {
  const normalizedMainAnswer = mainAnswer || ''
  const normalizedCurrentAnswer = currentAnswer || ''

  const isQuestionSelected = selectedQuestionIndex !== 0
  const isQuestionEdited = mainQuestion !== currentQuestion
  const isAnswerUpdated = normalizedCurrentAnswer !== normalizedMainAnswer

  const canBeUpdated = useMemo(() => {
    return questionsLength === 1
      ? isAnswerUpdated || isQuestionEdited
      : isQuestionSelected || isQuestionEdited || isAnswerUpdated
  }, [currentAnswer, currentQuestion, selectedQuestionIndex])

  return { canBeUpdated }
}
